import { Typography } from "@mui/material";
import { FC, PropsWithChildren } from "react";

export type InsidePageTitleProps = PropsWithChildren<{}>;

export const InsidePageTitle: FC<InsidePageTitleProps> = (props) => {
  return <Typography variant="h2">{props.children}</Typography>;
};
